import { Component, Inject } from "@angular/core";
import { FormControl, Validators, FormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CustomValidators } from "ng2-validation";
import {
  PasswordPolicyGQL,
  UnblockUserGQL,
  ChangePlatformUserPasswordGQL
} from "../../../../generated/graphql";
import { SnackBarService } from "../../../shared/service/snack.bar.service";
import { FormValidators } from "../../../shared/form-validators/form-validators";
import { GraphQLError } from "graphql";
import JSEncrypt from "jsencrypt";
import { environment } from "../../../../environments/environment";

export interface DialogData {
  type: string;
  userId: string;
  isPlatformUser: boolean;
}

@Component({
  selector: "unblock-user-dialog",
  templateUrl: "unblock-user-dialog.html",
})
export class UnblockUserDialog {
  private errorMessages: {};
  formGrp: FormGroup;
  formType: string;
  visibility: any = {
    new: false,
    confirm: false,
  };

  constructor(
    public dialogRef: MatDialogRef<UnblockUserDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private passwordPolicyGQL: PasswordPolicyGQL,
    private unblockUserGQL: UnblockUserGQL,
    private snackSvc: SnackBarService,
    private changePlatformUserPasswordGQL: ChangePlatformUserPasswordGQL
  ) {
    this.formType = data.type;
    this.initFormControl();
  }

  private initFormControl() {
    const newPasswordFormCtrl = new FormControl("", Validators.required);
    const confirmPasswordFormCtrl = new FormControl("", [
      Validators.required,
      CustomValidators.equalTo(newPasswordFormCtrl),
    ]);

    this.formGrp = new FormGroup({
      NewPassword: newPasswordFormCtrl,
      ConfirmPassword: confirmPasswordFormCtrl,
    });
    this.validatePassword();
  }

  private validatePassword() {
    this.passwordPolicyGQL.fetch().subscribe((result) => {
      if (result.errors) {
        this.snackSvc.show(result.errors.map((x) => x.message).join(","));
        //this.navigationService.backPerviousPage();
      }

      let policy = result.data.passswordPolicy;
      this.errorMessages = policy.ErrorMsg;
      let newPasswordFormCtrl = this.formGrp.controls["NewPassword"];
      let confirmPasswordFormCtrl = this.formGrp.controls["ConfirmPassword"];
      let validations = [Validators.required];

      if (policy.RequiredLength) {
        validations.push(Validators.minLength(policy.RequiredLength));
      }
      if (policy.RequireNonAlphanumeric) {
        validations.push(
          FormValidators.PasswordValidator.RequireNonAlphanumeric()
        );
      }
      if (policy.RequireDigit) {
        validations.push(FormValidators.PasswordValidator.RequireDigit());
      }
      if (policy.RequireLowercase) {
        validations.push(FormValidators.PasswordValidator.RequireLowercase());
      }
      if (policy.RequireUppercase) {
        validations.push(FormValidators.PasswordValidator.RequireUppercase());
      }
      if (policy.RequiredUniqueChars) {
        validations.push(
          FormValidators.PasswordValidator.RequiredUniqueChars(
            policy.RequiredUniqueChars
          )
        );
      }
      newPasswordFormCtrl.setValidators(Validators.compose(validations));
      confirmPasswordFormCtrl.setValidators(
        Validators.compose([
          Validators.required,
          CustomValidators.equalTo(newPasswordFormCtrl),
        ])
      );

      newPasswordFormCtrl.updateValueAndValidity();
      confirmPasswordFormCtrl.updateValueAndValidity();
    });
  }

  getErrorMessage(controlName: string) {
    let control = this.formGrp.get(controlName);

    if (control.hasError("required") && controlName == "NewPassword") {
      return "New Password is required.";
    }
    if (control.hasError("minlength")) {
      return this.errorMessages["RequiredLength"];
    }
    if (control.hasError("RequireDigit")) {
      return this.errorMessages["RequireDigit"];
    }
    if (control.hasError("RequireLowercase")) {
      return this.errorMessages["RequireLowercase"];
    }
    if (control.hasError("RequireUppercase")) {
      return this.errorMessages["RequireUppercase"];
    }
    if (control.hasError("RequireNonAlphanumeric")) {
      return this.errorMessages["RequireNonAlphanumeric"];
    }
    if (control.hasError("RequiredUniqueChars")) {
      return this.errorMessages["RequiredUniqueChars"];
    }
  }

  toggleVisibility(type) {
    this.visibility[type] = !this.visibility[type];
  }
  public PasswordEncrypt(password: string): string {
    let jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(environment.PasswordPublicKey);
    return jsEncrypt.encrypt(password);
  }

  submit(value) {
    if (this.formGrp.valid) {
      if (this.data.isPlatformUser == true){
        const encryptedPass = this.PasswordEncrypt(value.NewPassword);
        this.changePlatformUserPasswordGQL
            .mutate({
              userId: this.data.userId,
              newPassword: encryptedPass,
              confirmPassword: encryptedPass,
            })
            .subscribe(
              () => {
                this.dialogRef.close(true);
                this.snackSvc.show("Password Changed Successfully");
              },
              (err: GraphQLError) => {
                this.snackSvc.showMutationError(err);
              }
            );
      } else {
      if (this.data.type == "password") {
        this.unblockUserGQL
          .mutate({
            userId: this.data.userId,
            newPassword: this.PasswordEncrypt(value.NewPassword),
            confirmPassword: this.PasswordEncrypt(
              value.ConfirmPassword
            ),
          })
          .subscribe(
            () => {
              this.dialogRef.close(true);
              this.snackSvc.show("Password Changed Successfully");
            },
            (err: GraphQLError) => {
              this.snackSvc.showMutationError(err);
            }
          );
      } else {
        this.unblockUserGQL
          .mutate({
            userId: this.data.userId,
            newPassword: this.PasswordEncrypt(value.NewPassword),
            confirmPassword: this.PasswordEncrypt(
              value.ConfirmPassword
            ),
          })
          .subscribe(
            () => {
              this.dialogRef.close(true);
              this.snackSvc.show("Unblock Successfully.");
            },
            (err: GraphQLError) => {
              this.snackSvc.showMutationError(err);
            }
          );
      }
      }
    } else {
      this.snackSvc.show("Please complete or correct the required field(s).");
    }
  }
}
